import React from 'react'

export default function ModalLarge(props) {
    return <>
        <div class="modal fade" id={props.id} tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h6 class="modal-title" style={{ textTransform: 'uppercase' }} id="largeModalLabel"> {props.titulo}</h6>
                    </div>

                    <div class="modal-body">
                        <div className="content">
                            {props.children}
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-link waves-effect btn-light" data-dismiss="modal"> FECHAR </button>
                    </div>
                </div>
            </div>
        </div>
    </>
}
